module.exports = [{"name":"github","link":"https://github.com/evansimonross","classNames":["fab","fa-github","fa-8x"]},{"name":"linkedin","link":"https://www.linkedin.com/in/evansimonross/","classNames":["fab","fa-linkedin","fa-8x"]},{"name":"email","link":"mailto:evan.simon.ross@gmail.com","classNames":["far","fa-envelope","fa-8x"]},{"name":"resume","link":"/document/Evan_Simon_Ross_Resume.pdf","link_type":"internal","classNames":["fas","fa-file-invoice","fa-8x"]}]


//////////////////
// WEBPACK FOOTER
// ./src/pages/Contact/social.json
// module id = 175
// module chunks = 0